export const adaptTipoCapacitacion = (tipoCapacitacionData) => {
    return {
        id: tipoCapacitacionData?.idTipoCapacitacion,
        displayName: tipoCapacitacionData?.nombre,
        name: tipoCapacitacionData?.nombre,
        idTipoProfesional: tipoCapacitacionData?.idTipoProfesional
    }
}

export const adaptTipoCapacitacionArray = (
    tiposCapacitacion
) => {
    return structuredClone(tiposCapacitacion?.allTipoCapacitacion)
        ?.map(tipoCapacitacion => adaptTipoCapacitacion(tipoCapacitacion));
}